import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSBackdrop from '@elliemae/ds-backdrop';
import DSPortal from '@elliemae/ds-portal';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'overlay';
var events = ['mousedown', 'touchstart'];
var OverlayContainer = aggregatedClasses('div')(blockName, null, function (_ref) {
  var usePortal = _ref.usePortal,
      isOpen = _ref.isOpen;
  return {
    inline: !usePortal,
    opened: isOpen
  };
});

var DSOverlay = /*#__PURE__*/function (_Component) {
  _inherits(DSOverlay, _Component);

  var _super = _createSuper(DSOverlay);

  function DSOverlay(props) {
    var _this;

    _classCallCheck(this, DSOverlay);

    _this = _super.call(this, props);
    _this.overlayRef = /*#__PURE__*/React.createRef();
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DSOverlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (isOpen !== prevProps.isOpen) {
        if (isOpen) {
          this.openOverlay();
        } else {
          this.closeOverlay();
        }
      }
    }
  }, {
    key: "addClickOutsideListeners",
    value: function addClickOutsideListeners() {
      var _this2 = this;

      events.forEach(function (event) {
        document.addEventListener(event, _this2.handleDocumentClick);
      });
    }
  }, {
    key: "removeClickOutsideListeners",
    value: function removeClickOutsideListeners() {
      var _this3 = this;

      events.forEach(function (event) {
        document.removeEventListener(event, _this3.handleDocumentClick);
      });
    }
  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(e) {
      var _this$props = this.props,
          onClickOutside = _this$props.onClickOutside,
          isOpen = _this$props.isOpen;
      var overlayStack = DSOverlay.overlayStack;
      var overlayIndex = overlayStack.indexOf(this);
      var hasClickedOverlay = overlayStack.slice(overlayIndex).some(function (_ref2) {
        var overlayRef = _ref2.overlayRef;
        var elem = overlayRef.current;
        return elem && elem.contains(e.target) && !elem.isSameNode(e.target);
      });

      if (isOpen && !hasClickedOverlay) {
        onClickOutside(e); // giving opportunity for callers to operate on the event.
      }
    }
  }, {
    key: "openOverlay",
    value: function openOverlay() {
      this.addClickOutsideListeners();
      DSOverlay.overlayStack.push(this);
    }
  }, {
    key: "closeOverlay",
    value: function closeOverlay() {
      var overlayStack = DSOverlay.overlayStack;
      var overlayIndex = overlayStack.indexOf(this);
      this.removeClickOutsideListeners();
      overlayStack.splice(overlayIndex, 1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          usePortal = _this$props2.usePortal,
          isOpen = _this$props2.isOpen,
          hasBackdrop = _this$props2.hasBackdrop,
          children = _this$props2.children,
          backDropZIndex = _this$props2.backDropZIndex;
      if (!isOpen) return null;
      var overlay = /*#__PURE__*/React.createElement(OverlayContainer, {
        classProps: {
          usePortal: usePortal,
          isOpen: isOpen
        },
        innerRef: this.overlayRef
      }, hasBackdrop && /*#__PURE__*/React.createElement(DSBackdrop, {
        zIndex: backDropZIndex
      }), children);

      if (usePortal) {
        return /*#__PURE__*/React.createElement(DSPortal, null, overlay);
      }

      return overlay;
    }
  }]);

  return DSOverlay;
}(Component);

_defineProperty(DSOverlay, "overlayStack", []);

_defineProperty(DSOverlay, "defaultProps", {
  isOpen: false,
  usePortal: true,
  hasBackdrop: false,
  backDropZIndex: 2,
  // https://jira.elliemae.io/browse/PUI-1712
  onClickOutside: function onClickOutside() {
    return null;
  }
});

DSOverlay.propTypes = {
  backDropZIndex: PropTypes.number,
  children: PropTypes.element,
  hasBackdrop: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClickOutside: PropTypes.func,
  usePortal: PropTypes.bool
};

export default DSOverlay;
export { DSOverlay };
//# sourceMappingURL=DSOverlay.js.map
